import styles from './styles.css';
import {template} from './template';
import '@aofl/drawer';
import {AoflElement, customElement, property} from '@aofl/element';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../../constants-enumerate';

/**
 * @summary TabContent
 * @class TabContent
 * @extends {AoflElement}
 */
@customElement('tab-content')
class TabContent extends mapStatePropertiesMixin(AoflElement) {
  /**
   * Creates an instance of TabContent.
   * @memberof TabContent
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
  }


  /**
   * @readonly
   * @static
   * @memberof TabContent
   */
  static is = 'tab-content';

  @property({type: String})
  groupId = 'ungrouped';
  @property({type: String})
  tabId = '';
  @property({type: Boolean})
  drawerState = false;
  /**
   *
   *
   * @memberof TabContent
   */
  mapStateProperties() {
    const state = this.storeInstance.getState();
    this.drawerState = state[sdoNs.TABS][this.groupId][this.tabId];
  }
  /**
   *
   *
   * @return {Object}
   * @memberof TabContent
   */
  render() {
    return super.render(template, [styles]);
  }
}

export {
  TabContent
};
